'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M877.254 402.746l-320-320c-24.992-24.994-65.514-24.994-90.508 0l-320 320c-24.994 24.994-24.994 65.516 0 90.51 24.994 24.996 65.516 24.996 90.51 0l210.744-210.746v613.49c0 35.346 28.654 64 64 64s64-28.654 64-64v-613.49l210.746 210.746c12.496 12.496 28.876 18.744 45.254 18.744s32.758-6.248 45.254-18.746c24.994-24.994 24.994-65.514 0-90.508z' })
    ));
};